import { connect, MapStateToProps } from 'react-redux';
import { Props } from '@wix/da-shared-react/pkg/Duperbrowse/DeviationDuperbrowseContext';
import { AppState } from '../../../types/store';
import { getBiExtraData } from '../../selectors/biLogger';

type Parent = NonNullable<Props['parent']>;
type ParentWithoutBI = Pick<Parent, Exclude<keyof Parent, 'typeId' | 'itemId'>>;

export type StateProps = Pick<Props, 'parent'>;
export type OwnProps = Omit<Props, keyof StateProps> & {
  parent: ParentWithoutBI;
  children: any;
};

const mapStateToProps: MapStateToProps<StateProps, OwnProps, AppState> = (
  state,
  { parent }
) => {
  const { typeid, itemid } = getBiExtraData(state);
  return {
    parent: {
      ...parent,
      typeId: typeid,
      itemId: itemid,
    },
  };
};

export default connect(mapStateToProps);
